import React, { useEffect, useState } from 'react';

export default function Menu() {
    const [usuario, setUsuario] = useState({})
    const pagina = window.location.pathname;
    const tipo = new URLSearchParams(window.location.search).get('tipo');

    useEffect(() => {
        const user = JSON.parse(localStorage.getItem('userd7'))
        console.log(user)
        setUsuario(user)
    }, [])
    return (
        <aside id="layout-menu" className="layout-menu menu-vertical menu bg-menu-theme">
            <div className="app-brand demo">
                <a href={usuario?.perfil === 'ATLETA_PROFISSIONAL' ? '/dashboardAtleta' : '/home'} className="app-brand-link">
                    {/* <span className="app-brand-logo demo">
                        <img style={{ width: '80%' }} src="https://entregaja.com.br/assets/images/logo/logo.png" />
                    </span> */}
                    <span className="app-brand-text demo menu-text fw-bolder ms-2">TvCombate</span>
                </a>
                <a href="javascript:void(0);" className="layout-menu-toggle menu-link text-large ms-auto d-block d-xl-none">
                    <i className="bx bx-chevron-left bx-sm align-middle" />
                </a>
            </div>
            <div className="menu-inner-shadow" />
            {usuario?.perfil === 'ATLETA_PROFISSIONAL' ?
                <ul className="menu-inner py-1">
                    <li className={`menu-item${pagina === '/dashboardAtleta' ? ' active' : ''}`}>
                        <a href="/dashboardAtleta" className="menu-link">
                            <i className="menu-icon tf-icons bx bx-home-circle" />
                            <div data-i18n="Analytics">Dashboard</div>
                        </a>
                    </li>
                    <li className={`menu-item${pagina === '/homeAtleta' && tipo === 'eventos' ? ' active' : ''}`}>
                        <a href="/homeAtleta?tipo=eventos" className="menu-link">
                            <i className="menu-icon tf-icons bx bx-video" />
                            <div>Vídeos</div>
                        </a>
                    </li>
                    <li className={`menu-item${pagina === '/homeAtleta' && tipo === 'transmissao' ? ' active' : ''}`}>
                        <a href="/homeAtleta?tipo=transmissao" className="menu-link">
                            <i className="menu-icon tf-icons bx bx-tv" />
                            <div>Transmissões</div>
                        </a>
                    </li>
                </ul>
                : usuario?.perfil === 'ADMIN' ?
                <ul className="menu-inner py-1">
                    <li className="menu-item active">
                        <a href="/admin" className="menu-link">
                            <i className="menu-icon tf-icons bx bx-home-circle" />
                            <div data-i18n="Analytics">Dashboard</div>
                        </a>
                    </li>
                    <li className="menu-item">
                        <a href="/eventos" className="menu-link menu-toggle">
                            <i className="menu-icon tf-icons bx bx-home" />
                            <div data-i18n="Account Settings">Vídeos</div>
                        </a>
                    </li>
                    <li className="menu-item">
                        <a href="/transmissoes" className="menu-link menu-toggle">
                            <i className="menu-icon tf-icons bx bx-tv" />
                            <div data-i18n="Account Settings">Transmissões</div>
                        </a>
                    </li>
                    <li className="menu-item">
                        <a href="/usuarios" className="menu-link menu-toggle">
                            <i className="menu-icon tf-icons bx bx-user" />
                            <div data-i18n="Account Settings">Usuarios</div>
                        </a>
                    </li>
                    <li className="menu-item">
                        <a href="/produtores" className="menu-link menu-toggle">
                            <i className="menu-icon tf-icons bx bx-user" />
                            <div data-i18n="Account Settings">Produtores</div>
                        </a>
                    </li>
                    <li className="menu-item">
                        <a href="/pagamentos" className="menu-link menu-toggle">
                            <i className="menu-icon tf-icons bx bx-money" />
                            <div data-i18n="Account Settings">Pagamentos</div>
                        </a>
                    </li>
                    <li className="menu-item">
                        <a href="/informacoes" className="menu-link menu-toggle">
                            <i className="menu-icon tf-icons bx bx-file" />
                            <div data-i18n="Account Settings">Informações</div>
                        </a>
                    </li>
                    <li className="menu-item">
                        <a href="/auditoria" className="menu-link menu-toggle">
                            <i className="menu-icon tf-icons bx bx-file" />
                            <div data-i18n="Account Settings">Auditoria</div>
                        </a>
                    </li>
                    <li className="menu-item">
                        <a href="/emailMarketing" className="menu-link menu-toggle">
                            <i className="menu-icon tf-icons bx bx-envelope" />
                            <div data-i18n="Account Settings">Email Marketing</div>
                        </a>
                    </li>
                    <li className="menu-item">
                        <a href="/servicosExtras" className="menu-link menu-toggle">
                            <i className="menu-icon tf-icons bx bx-envelope" />
                            <div data-i18n="Account Settings">Serviços Extras</div>
                        </a>
                    </li>

                </ul>
                :
                <ul className="menu-inner py-1">
                    <li className="menu-item active">
                        <a href="/admin" className="menu-link">
                            <i className="menu-icon tf-icons bx bx-home-circle" />
                            <div data-i18n="Analytics">Dashboard</div>
                        </a>
                    </li>
                    <li className="menu-item">
                        <a href="/eventos" className="menu-link menu-toggle">
                            <i className="menu-icon tf-icons bx bx-home" />
                            <div data-i18n="Account Settings">Eventos</div>
                        </a>
                    </li>
                    <li className="menu-item">
                        <a href="/transmissoes" className="menu-link menu-toggle">
                            <i className="menu-icon tf-icons bx bx-tv" />
                            <div data-i18n="Account Settings">Transmissões</div>
                        </a>
                    </li>
                    <li className="menu-item">
                        <a href="/pagamentos" className="menu-link menu-toggle">
                            <i className="menu-icon tf-icons bx bx-money" />
                            <div data-i18n="Account Settings">Pagamentos</div>
                        </a>
                    </li>
                    {/* <li className="menu-item">
                        <a href="/convidados" className="menu-link menu-toggle">
                            <i className="menu-icon tf-icons bx bx-user" />
                            <div data-i18n="Account Settings">Convidados</div>
                        </a>
                    </li> */}

                </ul>
            }


        </aside>
    );
}

